/* eslint-disable no-useless-constructor */
/* eslint-disable no-restricted-syntax */
import { Validation } from 'common/domain/entities/validation';
import { FieldValidation } from '../../protocols/field-validation';

export class ValidationComposite implements Validation {
	private constructor(private readonly validators: FieldValidation[]) {}

	static build(validators: FieldValidation[]): ValidationComposite {
		return new ValidationComposite(validators);
	}

	validate(fieldName: string, input: object): string {
		const validators = this.validators.filter((v) => v.field === fieldName);
		for (const validator of validators) {
			const error = validator.validate(input);
			if (error) {
				return error.message;
			}
		}
		return '';
	}
}
